import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { MeiucaAppLayout } from '../components/MeiucaAppLayout';
import { SearchGamesList } from '../components/SearchGamesList';
import { shareGame } from '../utils/shareUtils';

export default function HomePage() {
  const navigate = useNavigate();

  const handleGameClick = (gameId: string) => {
    navigate(`/app/games/${gameId}`);
  };

  return (
    <MeiucaAppLayout>
      <div className="p-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <SearchGamesList 
            onGameClick={handleGameClick}
            onShare={shareGame}
          />
        </motion.div>
      </div>
    </MeiucaAppLayout>
  );
}